// @flow

import React, { Component, type Node } from 'react';
import { Flex } from 'clark-styles';
import LinkIcon from 'assets/icons/link.svg';
import ModalAndTrigger from 'containers/modal-and-trigger';
import CancelButton from 'components/button-cancel';
import FaqLink from 'components/faq-link';
import userAuth from 'utils/user-auth';
import { MenuItemLink, RightMargin } from '../styles';
import { Copy, Wrapper, Headline, SubmitButton } from './styles';

const ModalTrigger = ({ toggleModal }: { toggleModal(): void }): Node => (
  <MenuItemLink as="button" onClick={toggleModal}>
    <Flex alignItems="center" justifyContent="flex-end">
      <RightMargin>
        <LinkIcon />
      </RightMargin>
      Sync To My Calendar
    </Flex>
  </MenuItemLink>
);

type PropsType = {
  subscribe(): Object,
  unsubscribe(): Object,
  toggleModal(): void,
};
type StateType = { success: boolean, isSubscribedToOwnGoogleCalendar: boolean };

class CalendarSyncModal extends Component<PropsType, StateType> {
  state = {
    success: false,
    isSubscribedToOwnGoogleCalendar: userAuth.get().attributes.isSubscribedToOwnGoogleCalendar,
  };

  markSuccessful = () => {
    this.setState({ success: true });
  };

  render() {
    const { subscribe, unsubscribe, toggleModal } = this.props;
    const { success, isSubscribedToOwnGoogleCalendar } = this.state;

    const { attributes: { email } = {} } = userAuth.get();

    return isSubscribedToOwnGoogleCalendar ? (
      <Wrapper>
        <Flex justifyContent="space-between">
          <Headline>You’re already syncing events to your gmail account</Headline>
          <CancelButton onClick={toggleModal} />
        </Flex>
        <Copy>
          If you aren’t seeing the events in your google calendar, try unsubscribing and re-syncing.
        </Copy>
        <FaqLink copy="Learn more about syncing your calendar" link="/" />
        <Flex justifyContent="center">
          <SubmitButton
            onClick={() =>
              unsubscribe()
                .then(toggleModal)
                .catch(e => console.log(e))
            }
            type="button"
            layout="fullWidth"
          >
            Unsubscribe
          </SubmitButton>
        </Flex>
      </Wrapper>
    ) : (
      <Wrapper>
        <Flex justifyContent="space-between">
          <Headline>{success ? 'Connected!' : 'Sync to your Google Calendar'}</Headline>
          <CancelButton onClick={toggleModal} />
        </Flex>
        <Copy>
          {success
            ? 'Give your calendar a few minutes to populate all the info and then you should see all your Clark sessions there'
            : `This will automatically send all your Clark sessions and any future updates to the email on your account, ${email}`}
        </Copy>
        {success || (
          <FaqLink
            copy="Learn more about syncing your calendar"
            link="https://support.hiclark.com/account-setup/google-calendar-sync-101-for-tutors"
          />
        )}
        <Flex justifyContent="center">
          <SubmitButton
            onClick={
              success
                ? toggleModal
                : () =>
                    subscribe()
                      .then(this.markSuccessful)
                      .catch(e => console.log(e))
            }
            type="button"
            layout="fullWidth"
          >
            {success ? 'Got It!' : 'Connect My Google Account'}
          </SubmitButton>
        </Flex>
      </Wrapper>
    );
  }
}

type TriggerPropsType = {
  subscribe(): Object,
  unsubscribe(): Object,
};

const CalendarSyncModalTrigger = ({ subscribe, unsubscribe }: TriggerPropsType) => (
  <ModalAndTrigger
    modalContentLabel="calendar-sync-modal"
    renderModalContent={toggleModal => (
      <CalendarSyncModal
        subscribe={subscribe}
        unsubscribe={unsubscribe}
        toggleModal={toggleModal}
      />
    )}
    renderModalTrigger={toggleModal => <ModalTrigger toggleModal={toggleModal} />}
  />
);

export default CalendarSyncModalTrigger;



// WEBPACK FOOTER //
// ./src/containers/settings-dropdown/calendar-sync-modal/index.js